import React, { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { routes } from "./routes";
import { AppContainer } from "./style";
import AppContext from "../../components/Context/AppContext";
import "normalize.css";

const App = () => {
  const [username, setUsername] = useState("");
  const [room, setRoom] = useState("");
  const [chatList, setChatList] = useState([]);
  const [websocket, setWebsocket] = useState(null);
  const [members, setMembers] = useState([]);
  const [isStarted, setIsStarted] = useState(false);
  const [role, setRole] = useState("");
  const [turn, setTurn] = useState("");
  const [isGameStarter, setIsGameStarter] = useState(false);
  const [isDead, setIsDead] = useState(false);

  const userState = {
    room,
    username,
    chatList,
    websocket,
    members,
    isStarted,
    role,
    turn,
    isGameStarter,
    isDead,
    setRoom,
    setUsername,
    setChatList,
    setWebsocket,
    setMembers,
    setIsStarted,
    setRole,
    setTurn,
    setIsGameStarter,
    setIsDead,
  };

  const pages = routes.map((route) => (
    <Route
      key={route.key}
      component={route.component}
      exact={route.exact}
      path={route.path}
    />
  ));

  return (
    <AppContext.Provider value={userState}>
      <AppContainer>
        <Router>
          <Switch>{pages}</Switch>
        </Router>
      </AppContainer>
    </AppContext.Provider>
  );
};

export default App;
